module.exports = __webpack_public_path__ + "img/sos-logo.1cd52fe4.png";